import { Icon } from '@coop/components';
import { ChevronRightIcon } from '@coop/icons';
import classnames from 'classnames';

import type { ProductProps } from '../../../common/models/props/itemTeaserProps';
import { SustainabilityLights } from '../SustainabilityLights';
import styles from './SustainabilityDeclarationButton.module.scss';

const SustainabilityButton = (props: {
    sustainabilityInfo: ProductProps['sustainabilityInfo'];
    className?: string;
    handleClick: () => void;
}) => {
    return props.sustainabilityInfo ? (
        <button
            type="button"
            className={classnames(styles.Button, props.className)}
            onClick={props.handleClick}
            aria-haspopup="dialog"
            aria-labelledby="SustainabilityButton_Name SustainabilityButton_Lights"
        >
            <span aria-hidden id="SustainabilityButton_Name" className={styles.Text}>
                Hur hållbar är varan?
            </span>
            <div className={styles.LightsContainer}>
                <div style={{ width: 68 }}>
                    <SustainabilityLights
                        aria-hidden
                        id="SustainabilityButton_Lights"
                        productScores={props.sustainabilityInfo}
                    />
                </div>
                <Icon icon={ChevronRightIcon} width={24} height={24} aria-hidden />
            </div>
        </button>
    ) : (
        <button
            type="button"
            className={classnames(styles.Button, props.className, styles.Disabled)}
            onClick={props.handleClick}
            aria-haspopup="dialog"
            aria-label="Hållbarhetsdeklaration saknas för denna produkt. Klicka för att se varför."
        >
            Hållbarhetsdeklaration saknas
            <Icon icon={ChevronRightIcon} width={24} height={24} aria-hidden />
        </button>
    );
};

export default SustainabilityButton;
